import React from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  Container,
  Grid,
  InputAdornment,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import HomeIcon from "@mui/icons-material/Home";
import BedIcon from "@mui/icons-material/Bed";
import BathtubIcon from "@mui/icons-material/Bathtub";
import SquareFootIcon from "@mui/icons-material/SquareFoot";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2C3E50",
    },
    secondary: {
      main: "#3498DB",
    },
    background: {
      default: "#F5F7FA",
    },
    text: {
      primary: "#34495E",
    },
    error: {
      main: "#E74C3C",
    },
    success: {
      main: "#2ECC71",
    },
  },
});

const featuredListings = [
  // ... (your existing listings data)
];

const Home = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ backgroundColor: "background.default", minHeight: "100vh" }}>
        <Container maxWidth="lg">
          <Box py={8}>
            <Typography
              variant="h2"
              align="center"
              gutterBottom
              fontWeight="bold"
              color="primary"
            >
              Find Your Dream Home
            </Typography>

            <Box maxWidth="sm" mx="auto" mb={6}>
              <TextField
                fullWidth
                label="Enter an address, neighborhood, city, or ZIP code"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
                sx={{ mt: 2, py: 1.5 }}
              >
                Search Homes
              </Button>
            </Box>

            <Typography
              variant="h4"
              align="center"
              gutterBottom
              color="text.secondary"
            >
              Featured Listings
            </Typography>

            <Grid container spacing={4} mb={6}>
              {featuredListings.map((listing) => (
                <Grid item xs={12} sm={6} key={listing.id}>
                  <Card elevation={3}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        <HomeIcon
                          color="secondary"
                          sx={{ mr: 1, verticalAlign: "middle" }}
                        />
                        {listing.address}
                      </Typography>
                      <Typography
                        variant="h5"
                        color="error"
                        gutterBottom
                        fontWeight="bold"
                      >
                        ${listing.price.toLocaleString()}
                      </Typography>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">
                          <BedIcon
                            fontSize="small"
                            sx={{ mr: 0.5, verticalAlign: "middle" }}
                          />
                          {listing.bedrooms} bd
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <BathtubIcon
                            fontSize="small"
                            sx={{ mr: 0.5, verticalAlign: "middle" }}
                          />
                          {listing.bathrooms} ba
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          <SquareFootIcon
                            fontSize="small"
                            sx={{ mr: 0.5, verticalAlign: "middle" }}
                          />
                          {listing.sqft} sqft
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default Home;
